<template>
  <div class="payment">
    <div class="main-inner">
      <main>
        <section class="form-content" v-if="this.step == 0">
          <h2 class="form-content-title">請求書記載情報変更</h2>
          <p class="form-content-desc">変更を希望する場合は、必要な情報を入力のうえ、下の「次へ」ボタンを押してください。</p>
          <div class="card-alert">※新しい請求先情報は、次回請求時からになります。</div>
          <div class="form-block">
            <div class="form-block-item --required">
              <div class="form-block-label">会社名・団体名</div>
              <div class="form-block-content">
                <input type="text" :class="{ '--error' : inputErrors.name }" placeholder="例）株式会社ひめこカンパニー" name="name"
                       v-model="invoiceInfo.name">
                <p class="form-error" v-if="inputErrors.name">入力に誤りがあります。</p>
              </div>
            </div>
            <div class="form-block-item --required">
              <div class="form-block-label">部署名</div>
              <div class="form-block-content">
                <input type="text" :class="{ '--error' : inputErrors.department }"
                       placeholder="例）営業部 ＊ない場合は「なし」と入力してください" name="department" v-model="invoiceInfo.department">
                <p class="form-error" v-if="inputErrors.department">入力に誤りがあります。</p>
                <p class="form-error" v-if="inputErrors.departmentLength">100文字以内で入力してください。</p>
              </div>
            </div>
            <div class="form-block-item --required">
              <div class="form-block-label">ご担当者様 お名前</div>
              <div class="form-block-content">
                <input type="text" :class="{ '--error' : inputErrors.address }" name="address" placeholder="例）苗字 名前"
                       v-model="invoiceInfo.address">
                <p class="form-error" v-if="inputErrors.address">入力に誤りがあります。</p>
              </div>
            </div>
            <div class="form-block-item --required">
              <div class="form-block-label">郵便番号</div>
              <div class="form-block-content">
                <input type="text" placeholder="例）1234567" :class="{ '--error' : inputErrors.zipcode }" name="zipcode"
                       v-model="invoiceInfo.zipcode" class="--zip">
                <button class="button --zip" @click="searchAddress(invoiceInfo.zipcode,'id')">自動入力</button>
                <p class="form-error" v-if="inputErrors.zipcode">7桁の数字で入力してください。
                </p>
              </div>
            </div>
            <div class="form-block-item --required">
              <div class="form-block-label">都道府県</div>
              <div class="form-block-content">
                <div class="form-select">
                  <select name="prefectures" v-model="prefecture" class="">
                    <option value="" selected>都道府県</option>
                    <option value="北海道">北海道</option>
                    <option value="青森県">青森県</option>
                    <option value="岩手県">岩手県</option>
                    <option value="宮城県">宮城県</option>
                    <option value="秋田県">秋田県</option>
                    <option value="山形県">山形県</option>
                    <option value="福島県">福島県</option>
                    <option value="茨城県">茨城県</option>
                    <option value="栃木県">栃木県</option>
                    <option value="群馬県">群馬県</option>
                    <option value="埼玉県">埼玉県</option>
                    <option value="千葉県">千葉県</option>
                    <option value="東京都">東京都</option>
                    <option value="神奈川県">神奈川県</option>
                    <option value="新潟県">新潟県</option>
                    <option value="富山県">富山県</option>
                    <option value="石川県">石川県</option>
                    <option value="福井県">福井県</option>
                    <option value="山梨県">山梨県</option>
                    <option value="長野県">長野県</option>
                    <option value="岐阜県">岐阜県</option>
                    <option value="静岡県">静岡県</option>
                    <option value="愛知県">愛知県</option>
                    <option value="三重県">三重県</option>
                    <option value="滋賀県">滋賀県</option>
                    <option value="京都府">京都府</option>
                    <option value="大阪府">大阪府</option>
                    <option value="兵庫県">兵庫県</option>
                    <option value="奈良県">奈良県</option>
                    <option value="和歌山県">和歌山県</option>
                    <option value="鳥取県">鳥取県</option>
                    <option value="島根県">島根県</option>
                    <option value="岡山県">岡山県</option>
                    <option value="広島県">広島県</option>
                    <option value="山口県">山口県</option>
                    <option value="徳島県">徳島県</option>
                    <option value="香川県">香川県</option>
                    <option value="愛媛県">愛媛県</option>
                    <option value="高知県">高知県</option>
                    <option value="福岡県">福岡県</option>
                    <option value="佐賀県">佐賀県</option>
                    <option value="長崎県">長崎県</option>
                    <option value="熊本県">熊本県</option>
                    <option value="大分県">大分県</option>
                    <option value="宮崎県">宮崎県</option>
                    <option value="鹿児島県">鹿児島県</option>
                    <option value="沖縄県">沖縄県</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="form-block-item --required">
              <div class="form-block-label">市区町村番地</div>
              <div class="form-block-content">
                <input type="text" :class="{ '--error' : inputErrors.municipalities }" placeholder="例）港区南青山5－15－9"
                       name="municipalities" v-model="invoiceInfo.municipalities">
                <p class="form-error" v-if="inputErrors.municipalities">
                  入力に誤りがあります。
                </p>
              </div>
            </div>
            <div class="form-block-item">
              <div class="form-block-label">建物名・部屋番号</div>
              <div class="form-block-content">
                <input type="text" placeholder="例）フラット青山 403号" name="building" v-model="invoiceInfo.building">
              </div>
            </div>
            <div class="form-block-item --required">
              <div class="form-block-label">請求書送付先（メールアドレス）</div>
              <div class="form-block-content">
                <input type="text" :class="{ '--error' : inputErrors.email }" name="email" placeholder="例）sample@xxx.jp"
                       v-model="invoiceInfo.email">
                <p class="form-error" v-if="inputErrors.email">メールアドレスの形式で入力してください。</p>
              </div>
            </div>
            <div class="form-block-item">
              <div class="form-block-label">請求書送付先2（メールアドレスCC）</div>
              <div class="form-block-content">
                <input type="text" :class="{ '--error' : inputErrors.email2 }" placeholder="例）sample@xxx.jp"
                       name="email2" v-model="invoiceInfo.email2">
                <p class="form-error" v-if="inputErrors.email2">メールアドレスの形式で入力してください。</p>
              </div>
            </div>
            <div class="form-block-item">
              <div class="form-block-label">請求書送付先3（メールアドレスCC）</div>
              <div class="form-block-content">
                <input type="text" :class="{ '--error' : inputErrors.email3 }" placeholder="例）sample@xxx.jp"
                       name="email3" v-model="invoiceInfo.email3">
                <p class="form-error" v-if="inputErrors.email3">メールアドレスの形式で入力してください。</p>
              </div>
            </div>
          </div>
          <div class="button-group">
            <button class="button" @click="$router.push('payment')">キャンセル</button>
            <button class="button" @click="isValidate()" :disabled="this.clicked">次へ</button>
          </div>
        </section>

        <section class="form-content" v-else-if="this.step == 1">
          <h2 class="form-content-title">変更内容確認</h2>
          <p class="form-content-desc">変更内容をご確認のうえ、お間違いがないようであれば、「変更する」ボタンを押してください。</p>
          <div class="payment-table change_info">
            <table>
              <tr>
                <th>会社名・団体名</th>
                <td>{{ invoiceInfo.name }}</td>
              </tr>
              <tr>
                <th>部署名</th>
                <td>{{ invoiceInfo.department }}</td>
              </tr>
              <tr>
                <th>ご担当者様 お名前</th>
                <td>{{ invoiceInfo.address }}</td>
              </tr>
              <tr>
                <th>郵便番号</th>
                <td>{{ invoiceInfo.zipcode }}</td>
              </tr>
              <tr>
                <th>都道府県</th>
                <td>{{ prefecture }}</td>
              </tr>
              <tr>
                <th>市区町村番地</th>
                <td>{{ invoiceInfo.municipalities }}</td>
              </tr>
              <tr v-if="invoiceInfo.building != ''">
                <th>建物名・部屋番号</th>
                <td>{{ invoiceInfo.building }}</td>
              </tr>
              <tr>
                <th>請求書送付先（メールアドレス）</th>
                <td>{{ invoiceInfo.email }}</td>
              </tr>
              <tr>
                <th>請求書送付先2（メールアドレスCC）</th>
                <td>{{ invoiceInfo.email2 }}</td>
              </tr>
              <tr>
                <th>請求書送付先3（メールアドレスCC）</th>
                <td>{{ invoiceInfo.email3 }}</td>
              </tr>
            </table>
          </div>
          <div class="button-group">
            <button class="button" @click="decreaseStep()">前の画面に戻る</button>
            <button class="button" @click="isCompleted()" :disabled="this.clicked">変更する</button>
          </div>
        </section>

        <section class="form-content" v-else-if="this.step == 2">
          <div class="lead mb-60">
            <h2 class="headline2 mb-10">
              請求書記載情報の変更が完了しました
            </h2>
            <p>
              ご登録のメールアドレス宛に、請求書記載情報変更完了メールをお送りいたしました。
              <br>
              <br>
              24時間を経過しても請求書記載情報変更完了メールが届かない場合は、お手数ですが、お問い合わせフォームからお問い合わせいただきますよう、お願いいたします。
            </p>
          </div>
          <div class="btn-set">
            <span class="button-group">
              <button class="button" @click="reloadTop()">請求書記載情報変更に戻る</button>
            </span>
          </div>
        </section>

        <section class="form-content" v-else-if="this.step == 3">
          <!-- 決済でエラーが起きた時 -->
          <h2 class="form-content-title">変更内容確認</h2>
          <p class="form-content-desc">{{ errMsg }}</p>
          <div class="btn-set">
            <span class="button-group">
              <button class="button" @click="reloadTop()">請求書記載情報変更に戻る</button>
            </span>
          </div>
        </section>
      </main>
    </div>
  </div>
</template>
<script>
import httpResource from '../../http/httpResource'
import {mapActions} from 'vuex'
import store from '../../store/index'

let YubinBango = require('yubinbango-core2')
export default {
  name: 'CardChange',
  data () {
    return {
      isError: false,
      clicked: false,
      prefecture: '',
      inputErrors: {},
      inputErrorsEmail2: {},
      inputErrorsEmail3: {},
      resultCode: '',
      errMsg: '',
      invoiceInfo: {
        // 請求書記載情報
        name: '',
        department: '',
        address: '',
        zipcode: '',
        prefectures: '',
        municipalities: '',
        building: '',
        email: '',
        email2: '',
        email3: ''
      },
      step: 0
    }
  },
  mounted () {
    this.reloadData()
  },
  methods: {
    ...mapActions(['login', 'updateContract']),
    async reloadData () {
      try {
        const response = await httpResource.get('/corporation/management/invoice', {headers: {Authorization: `Bearer ${store.getters.getAuthData.token}`}})
        if (response.status === 200) {
          let invoiceDetail = response.data
          this.invoiceInfo.name = invoiceDetail.name
          this.invoiceInfo.department = invoiceDetail.department
          this.invoiceInfo.address = invoiceDetail.address
          this.invoiceInfo.zipcode = invoiceDetail.zipcode
          this.prefecture = invoiceDetail.prefectures
          this.invoiceInfo.municipalities = invoiceDetail.municipalities
          this.invoiceInfo.building = invoiceDetail.building
          this.invoiceInfo.email = invoiceDetail.email
          this.invoiceInfo.email2 = invoiceDetail.email2
          this.invoiceInfo.email3 = invoiceDetail.email3
        }
      } catch (error) {
        console.log(error)
      }
    },
    searchAddress (zipCode, type) {
      let self = this
      let yubin = new YubinBango.Core(zipCode, function (addr) {
        if (type === 'id') {
          self.prefectures = addr.region
          self.invoiceInfo.municipalities = addr.locality + addr.street
        }
      })
      return yubin
    },
    checkClick () {
      this.clicked = true
    },
    increaseStep (step) {
      this.step += step
    },
    decreaseStep () {
      this.step -= 1
    },
    resetStep () {
      this.step = 0
    },
    async isCompleted () {
      this.checkClick()
      try {
        this.changePrefectures(this.prefecture)
        console.log('リクエストを送信')
        const response = await httpResource.post('/corporation/management/invoice', this.invoiceInfo, {headers: {Authorization: `Bearer ${store.getters.getAuthData.token}`}})
        if (response.status === 200) {
          console.log('レスポンスの受け取り')
          if (response.data.message === 'SUCCESS') {
            this.increaseStep(1)
          } else if (response.data.message === 'FAILURE') {
            this.errMsg = '請求書記載情報の変更に失敗しました、お問合せフォームからお問い合わせください。'
            this.increaseStep(2)
          } else {
            this.errMsg = response.data.message
            this.increaseStep(2)
          }
        }
      } catch (error) {
        console.log('レスポンスを受け取れない')
        console.log(error)
        this.increaseStep(3)
      }
    },
    changePrefectures (prefecture) {
      console.log(prefecture + '都道府県の変換')
      switch (prefecture) {
        case '北海道':
          this.invoiceInfo.prefectures = '1'
          break
        case '青森県':
          this.invoiceInfo.prefectures = '2'
          break
        case '岩手県':
          this.invoiceInfo.prefectures = '3'
          break
        case '宮城県':
          this.invoiceInfo.prefectures = '4'
          break
        case '秋田県':
          this.invoiceInfo.prefectures = '5'
          break
        case '山形県':
          this.invoiceInfo.prefectures = '6'
          break
        case '福島県':
          this.invoiceInfo.prefectures = '7'
          break
        case '茨城県':
          this.invoiceInfo.prefectures = '8'
          break
        case '栃木県':
          this.invoiceInfo.prefectures = '9'
          break
        case '群馬県':
          this.invoiceInfo.prefectures = '10'
          break
        case '埼玉県':
          this.invoiceInfo.prefectures = '11'
          break
        case '千葉県':
          this.invoiceInfo.prefectures = '12'
          break
        case '東京都':
          this.invoiceInfo.prefectures = '13'
          break
        case '神奈川県':
          this.invoiceInfo.prefectures = '14'
          break
        case '新潟県':
          this.invoiceInfo.prefectures = '15'
          break
        case '富山県':
          this.invoiceInfo.prefectures = '16'
          break
        case '石川県':
          this.invoiceInfo.prefectures = '17'
          break
        case '福井県':
          this.invoiceInfo.prefectures = '18'
          break
        case '山梨県':
          this.invoiceInfo.prefectures = '19'
          break
        case '長野県':
          this.invoiceInfo.prefectures = '20'
          break
        case '岐阜県':
          this.invoiceInfo.prefectures = '21'
          break
        case '静岡県':
          this.invoiceInfo.prefectures = '22'
          break
        case '愛知県':
          this.invoiceInfo.prefectures = '23'
          break
        case '三重県':
          this.invoiceInfo.prefectures = '24'
          break
        case '滋賀県':
          this.invoiceInfo.prefectures = '25'
          break
        case '京都府':
          this.invoiceInfo.prefectures = '26'
          break
        case '大阪府':
          this.invoiceInfo.prefectures = '27'
          break
        case '兵庫県':
          this.invoiceInfo.prefectures = '28'
          break
        case '奈良県':
          this.invoiceInfo.prefectures = '29'
          break
        case '和歌山県':
          this.invoiceInfo.prefectures = '30'
          break
        case '鳥取県':
          this.invoiceInfo.prefectures = '31'
          break
        case '島根県':
          this.invoiceInfo.prefectures = '32'
          break
        case '岡山県':
          this.invoiceInfo.prefectures = '33'
          break
        case '広島県':
          this.invoiceInfo.prefectures = '34'
          break
        case '山口県':
          this.invoiceInfo.prefectures = '35'
          break
        case '徳島県':
          this.invoiceInfo.prefectures = '36'
          break
        case '香川県':
          this.invoiceInfo.prefectures = '37'
          break
        case '愛媛県':
          this.invoiceInfo.prefectures = '38'
          break
        case '高知県':
          this.invoiceInfo.prefectures = '39'
          break
        case '福岡県':
          this.invoiceInfo.prefectures = '40'
          break
        case '佐賀県':
          this.invoiceInfo.prefectures = '41'
          break
        case '長崎県':
          this.invoiceInfo.prefectures = '42'
          break
        case '熊本県':
          this.invoiceInfo.prefectures = '43'
          break
        case '大分県':
          this.invoiceInfo.prefectures = '44'
          break
        case '宮崎県':
          this.invoiceInfo.prefectures = '45'
          break
        case '鹿児島県':
          this.invoiceInfo.prefectures = '46'
          break
        case '沖縄県':
          this.invoiceInfo.prefectures = '47'
          break
      }
    },
    async isValidate () {
      this.inputErrors = {}
      this.setEmailParameters()
      this.isError = false
      this.inputErrors = {
        ...this.inputErrors,
        name: this.invoiceInfo.name.length === 0,
        department: this.invoiceInfo.department.length === 0,
        departmentLength: this.invoiceInfo.department.length > 100,
        address: this.invoiceInfo.address.length === 0,
        zipcode: this.invoiceInfo.zipcode.length !== 7,
        municipalities: this.invoiceInfo.municipalities.length === 0,
        email: this.invoiceInfo.email.length === 0 || this.isInValidEmail(this.invoiceInfo.email),
        email2: (this.invoiceInfo.email2.length !== 0 && this.isInValidEmail(this.invoiceInfo.email2)),
        email3: (this.invoiceInfo.email3.length !== 0 && this.isInValidEmail(this.invoiceInfo.email3))
      }

      for (let key in this.inputErrors) {
        if (this.inputErrors[key] === true || this.inputErrorsEmail2.email2 === true || this.inputErrorsEmail3.email3 === true) {
          this.isError = true
        }
      }

      if (!this.isError) {
        this.increaseStep(1)
        window.scrollTo({top: 0})
      }
    },
    reloadTop () {
      this.$router.go({path: this.$router.currentRoute.path, force: true})
    },
    setEmailParameters () {
      if (this.invoiceInfo.email2 === null) {
        this.invoiceInfo.email2 = ''
      }

      if (this.invoiceInfo.email3 === null) {
        this.invoiceInfo.email3 = ''
      }
    },
    isInValidEmail (email) {
      if (email !== null) {
        const reg = new RegExp(/^[A-Za-z0-9]{1}[A-Za-z0-9/+_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/)
        return !reg.test(email)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/invoice/index.vue